import { Box, Stack, SxProps, Typography } from "@mui/material";

interface IBybSectionList {
  title?: string;
  spacing?: number;
  sx?: SxProps;
  children: React.ReactNode;
  childrenSx?: SxProps
}

const BybSectionList = ({ title, spacing = 1, sx, children, childrenSx}: IBybSectionList) => {
  return (
    <Stack sx={sx}>
      <Stack spacing={spacing} bgcolor={"dsBase.v100"}>
        {title && (
          <Box padding={2} boxSizing={"border-box"}>
            <Typography variant="text1xl600">{title}</Typography>
          </Box>
        )}
      </Stack>
      <Stack spacing={spacing} bgcolor={"dsSurface.v100"} sx={childrenSx}>
        {children}
      </Stack>
    </Stack>
  );
};

export default BybSectionList;
